import { useAppKitWallet } from '@reown/appkit-wallet-button/react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { WalletConnectWalletAdapter } from '@solana/wallet-adapter-wallets';
import { WALLET_BUTTON_ICON_CLASSNAME } from 'src/components/ConnectWalletButtonsList/WalletButton';
import ConnectWalletModalButton from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModalButton';

/**
 * We need to create a custom WalletConnect button because it needs to route through appkit/reown to be able to work after some weird bug/regression that was pushed through. We initialize this adapter just so that we can use the icon for the adapter, but otherwise we get the adapter through AppKit.
 */
const WalletConnectAdapter = new WalletConnectWalletAdapter({
	network: WalletAdapterNetwork.Mainnet,
	options: {},
});

export const WalletConnectWalletButton = () => {
	const { connect } = useAppKitWallet();

	const handleConnectWalletConnect = () => {
		connect('walletConnect');
	};

	return (
		<ConnectWalletModalButton onClick={handleConnectWalletConnect}>
			<div className={WALLET_BUTTON_ICON_CLASSNAME}>
				<img src={WalletConnectAdapter.icon} className="size-full" />
			</div>
			<span>WalletConnect</span>
		</ConnectWalletModalButton>
	);
};
